import React from "react";
import Typography from "@material-ui/core/Typography";

const H1 = (props: any) => (
  <Typography variant="h1" component="h1" gutterBottom {...props} />
);

export default H1;
